import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, hasMany } from '@apexdesigner/schema-tools';

export const activity = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z.string().nullable().optional().describe('Name'),

    optional: z
      .boolean()
      .nullable()
      .optional()
      .describe(
        'Optional - Not presented on a session unless the tutor adds it (opp 6733)',
      ),

    sequence: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Sequence - Display order'),

    locked: z.boolean().nullable().optional().hidden().describe('locked'),

    curriculumId: z.number().hidden().describe('Foreign key to Curriculum'),

    curriculum: belongsTo('Curriculum'),

    activityItems: hasMany('ActivityItem'),
  })
  .describe('A unit of work within a curriculum.')
  .as('Activity');

export { activity as activitySchema };
